<template>
    <div class="report-widget-advice mt-3"
         v-if="patientAdvice || (practitionerAdvice && canEdit)">

        <div class="mb-3 text-left"
             v-if="patientAdvice">
            <label v-if="canEdit">
                Patient Advice:
            </label>
            <div v-html="patientAdvice"></div>
        </div>

        <div class="mb-3 text-left"
             v-if="practitionerAdvice">
            <label>
                Practitioner Advice:
            </label>
            <div v-html="practitionerAdvice"></div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'

    /**
     * Displays advice for the Patient or Practitioner related to an individual score
     */
    export default Vue.extend({
        name: 'ReportWidgetAdvice',
        props: {
            scoreName: String,
        },
        computed: {
            canEdit () {
                return this.$user.practitionerId() != null && !this.$user.isMaskingPractitioner()
            },
            patientAdvice () {
                return this.$i18n.getPatientAdvice(this.scoreName)
            },
            practitionerAdvice () {
                return this.$i18n.getPractitionerAdvice(this.scoreName)
            },
        },
    })
</script>

<style lang="scss">
    .report-widget-advice {
        ul {
            margin-left: 20px;
        }
    }
</style>
